import React, { useContext } from 'react'
import { Container, Box, Flex, useColorMode,NavLink } from 'theme-ui'
import pageContextProvider from '@helpers/pageContextProvider'
import Search from '@widgets/Search'
import { HeaderLogo } from './Header.Logo'
import { HeaderMenu } from './Header.Menu'
import { HeaderColorMode } from './Header.ColorMode'
import { useBlogCategories } from '@helpers-blog'
import './style.css'
import { Link } from 'gatsby'
import Categories from './Header.Categories.jsx'
import { HeaderProfile } from './Header.Profile'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `headerBg`
  },
  container: {
    position: `relative`,
    zIndex: 10
  },
  logoContainer: {
    flexBasis: [`full`, `full`, `full`, `full`],
    display: [`none`, `flex`, `flex`, `flex`],
    justifyContent: ['end',`end`,`end`,`end`],
    marginRight:"30px"

  },

  searchContainer: {
    flexBasis: [`auto`, `auto`, `auto`, `auto`],
    minWidth: `auto`,
    order: [3, 3, null, `unset`],
    mx: 3,
    marginLeft:"2rem"
  },
  menuContainer: {
    flexBasis: [`auto`, `auto`, `auto`, `auto`],
    minWidth: `auto`,
    marginRight: '15px'
  },
  colorModeContainer: {
    minWidth: `auto`,
    order: [2, 2, 2, 2],
    marginRight: '6px',
  },
  profileContainer: {
    mx: '15px',
    width: '36px',
    flexBasis: [`auto`, `auto`, `auto`, `auto`],
    minWidth: `auto`,
    order: [4, 4, 4, 4]
  },
  menuCollection: {
    flexBasis: [`auto`, null, `1/3`],
    minWidth: `auto`,
    order: [4, null, `unset`]
  },
  logoMrAuto:{
    marginRight: `auto`
  },
  desktopMenuWrapper: {
    justifyContent: 'flex-end',
    fontSize: '1.2rem !important',
      color: '#B8C3CF !important',

    // '> a': {
    //   fontSize: '1.2rem !important',
    //   color: '#B8C3CF !important',
    // }
  }
}

export const Header = ({ children }) => {
  const context = useContext(pageContextProvider)

  const {headerMenu} = useSiteMetadata()

  const { services, mobileMenu, darkMode } = context.pageContext

  const algolia = services && services.algolia

  const [colorMode] = useColorMode()


  const headerMenuMobile = [
    ...headerMenu,
  ]

  return (
    <Box sx={styles.wrapper}>
      {/* <Container variant='compact' sx={styles.container}> */}
      <Flex id='header-wrapper' variant='layout.header'>
        <Box sx={styles.menuContainer}>
          <HeaderMenu mobileMenu={mobileMenu} />
        </Box>
        <Box sx={styles.logoMrAuto}>
          <HeaderLogo />
        </Box>

        {headerMenuMobile.map((items, index) => {
          if (items.slug == null) {
            return (
              <>
                <Box className='dropdown'>
                  {colorMode === 'dark' && (
                    <button class={'dropbtn'}>{items.name}</button>
                  )}
                  {colorMode === 'default' && (
                    <button class={'defaultDropBtn'}>{items.name}</button>
                  )}
                  <div class='dropdown-content'>
                    <Categories
                      categories={items.items}
                      variant='horizontal'
                      omitTitle
                    />
                  </div>
                </Box>
              </>
            )
          } else {
            return (
              <>
                <NavLink
                  className='dropdown'
                  sx={styles.desktopMenuWrapper}
                  href={`${items.slug}`}
                  p={2}
                >
                  {items.name}
                </NavLink>
              </>
            )

          }
        })}

        <Box sx={styles.searchContainer}>{algolia && <Search />}</Box>

        <Box sx={styles.colorModeContainer}>
          {darkMode && <HeaderColorMode />}
        </Box>

        {/* <Box sx={styles.profileContainer}> */}
          {/* <HeaderProfile /> */}
        {/* </Box> */}
      </Flex>
      {/* </Container> */}
      {children}
    </Box>
  )
}
